import React from 'react';
import Logo from '../../assets/img/logo.svg';

export default function CobrandHeader({ retailerName, retailerLogoUrl }) {
  const hasRetailer = Boolean(retailerLogoUrl || retailerName);
  return (
    <header className="k-cobrand-header">
      <img src={Logo} alt="Katapult" />
      {hasRetailer && (
        <>
          <span className="k-cobrand-header__with">with</span>
          <div className="k-cobrand-header__retailer-group">
            {retailerLogoUrl && <img className="k-cobrand-header__retailer-logo" src={retailerLogoUrl} alt="" />}
            {!retailerLogoUrl && retailerName && <span className="k-cobrand-header__retailer">{retailerName}</span>}
          </div>
        </>
      )}
    </header>
  );
}
